import React from 'react';
import PropTypes from 'prop-types';

const ProtectedTabContent = ({ tab, auth, children }) => {
    if (!auth?.user && tab?.needsLogin) {
        return (
            <div className="container">
                <br />
                <p>{tab.loginMessage || 'Log in to view this content.'}</p>
            </div>
        );
    }

    return children;
};

ProtectedTabContent.propTypes = {
    tab: PropTypes.shape({
        needsLogin: PropTypes.bool,
        loginMessage: PropTypes.string,
    }),
    auth: PropTypes.shape({
        user: PropTypes.object,
    }),
    children: PropTypes.node.isRequired,
};

ProtectedTabContent.defaultProps = {
    tab: null,
    auth: null,
};

export default ProtectedTabContent;
